import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const OuiNon = ({ name, value, onChange }) => (
  <div className="rb-oui-non">
    <label className="rb-radio-label">
      <input type="radio" name={name} value="oui"
        checked={value === "oui"} onChange={() => onChange("oui")} />
      Oui
    </label>
    <label className="rb-radio-label">
      <input type="radio" name={name} value="non"
        checked={value === "non"} onChange={() => onChange("non")} />
      Non
    </label>
  </div>
);

const Section = ({ title, confidence, children }) => (
  <div className="rb-bio-section">
    <div className="rb-section-label">
      {title}
      <ConfidenceLabel confidence={confidence} />
    </div>
    {children}
  </div>
);

const TabBiologie = ({ form, onChange, getConfidence, activeSub }) => {
  const gc  = getConfidence || (() => ({ exists: false }));
  const sub = activeSub || "hema_biochimie";

  return (
    <div className="rb-fields">
      {sub === "hema_biochimie" && 
      (
      <>
        {/* ── Hématologie ── */}
        <Section title="Hématologie" confidence={gc("bio_hema")}>
          <div className="rb-result-header">
            <OuiNon name="bio_hema" value={form.bio_hema ?? ""}
              onChange={(v) => onChange("bio_hema", v)} />
            <div className="rb-field-inline">
              <label>Date <ConfidenceLabel confidence={gc("bio_hema_date")} /></label>
              <input type="date" value={form.bio_hema_date ?? ""}
                onChange={(e) => onChange("bio_hema_date", e.target.value)}
                style={{ borderColor: gc("bio_hema_date").color || undefined }} />
            </div>
          </div>
          {form.bio_hema === "oui" && (
            <>
              <div className="rb-row">
                {[["GB(10³)/mm³","gb"],["PNN(%)","pnn"],["Lymphocytes(%)","lymphocytes"],["GR(10⁶)/mm³","gr"],["Hb(g/dL)","hb"],["Plaquettes(10³)/mm³","plaquettes"]].map(([label, key]) => {
                  return (
                    <div key={key} className="rb-field-group">
                      <label>{label} <ConfidenceLabel confidence={gc(`bio_hema_${key}`)} /></label>
                      <input
                        type="number"
                        min={0}
                        step={0.1}
                        placeholder="—"
                        value={form[`bio_hema_${key}`] ?? ""}
                        onChange={(e) => {
                          const val = Math.max(0, parseFloat(e.target.value) || 0).toString();
                          onChange(`bio_hema_${key}`, val);
                        }}
                        style={{ borderColor: gc(`bio_hema_${key}`).color || undefined }} />
                    </div>
                  );
                })}
              </div>
              <div className="rb-field-group">
                <label>Autres <ConfidenceLabel confidence={gc("bio_hema_autres")} /></label>
                <input type="text" placeholder="—"
                  value={form.bio_hema_autres ?? ""}
                  onChange={(e) => onChange("bio_hema_autres", e.target.value)}
                  style={{ borderColor: gc("bio_hema_autres").color || undefined }} />
              </div>
              <div className="rb-field-group">
                <label>Interprétation <ConfidenceLabel confidence={gc("bio_hema_interpretation")} /></label>
                <textarea rows={3} placeholder="Interprétation..."
                  value={form.bio_hema_interpretation ?? ""}
                  onChange={(e) => onChange("bio_hema_interpretation", e.target.value)}
                  style={{ borderColor: gc("bio_hema_interpretation").color || undefined }} />
              </div>
            </>
          )}
        </Section>

        {/* ── Biochimie ── */}
        <Section title="Biochimie" confidence={gc("bio_biochimie")}>
          <div className="rb-result-header">
            <OuiNon name="bio_biochimie" value={form.bio_biochimie ?? ""}
              onChange={(v) => onChange("bio_biochimie", v)} />
            <div className="rb-field-inline">
              <label>Date <ConfidenceLabel confidence={gc("bio_biochimie_date")} /></label>
              <input type="date" value={form.bio_biochimie_date ?? ""}
                onChange={(e) => onChange("bio_biochimie_date", e.target.value)}
                style={{ borderColor: gc("bio_biochimie_date").color || undefined }} />
            </div>
          </div>
          {form.bio_biochimie === "oui" && (
            <>
              <div className="rb-row">
                {[["Na(mmol/L)","na"],["K(mmol/L)","k"],["Ca(mmol/L)","ca"],["Protéines(g/L)","proteines"],["Ac. Urique(mg/L)","ac_urique"],["Créatinine(mg/L)","creatinine"],["LDH(UI/L)","ldh"],["Calcémie(mg/L)","calcemie"],["Phosphorémie(mg/L)","phosphoremie"],["Albuminémie(g/L)","albuminemie"]].map(([label, key]) => (
                  <div key={key} className="rb-field-group">
                    <label>{label} <ConfidenceLabel confidence={gc(`bio_biochimie_${key}`)} /></label>
                    <input type="number" placeholder="—" step="0.01"
                      value={form[`bio_biochimie_${key}`] ?? ""}
                      min={0}
                      onChange={(e) => {
                        const val = Math.max(0, parseFloat(e.target.value) || 0).toString();
                        onChange(`bio_biochimie_${key}`, val);
                      }}
                      style={{ borderColor: gc(`bio_biochimie_${key}`).color || undefined }} />
                  </div>
                ))}
              </div>
              <div className="rb-field-group">
                <label>Autres <ConfidenceLabel confidence={gc("bio_biochimie_autres")} /></label>
                <input type="text" placeholder="—"
                  value={form.bio_biochimie_autres ?? ""}
                  onChange={(e) => onChange("bio_biochimie_autres", e.target.value)}
                  style={{ borderColor: gc("bio_biochimie_autres").color || undefined }} />
              </div>
              <div className="rb-field-group">
                <label>Interprétation <ConfidenceLabel confidence={gc("bio_biochimie_interpretation")} /></label>
                <textarea rows={3} placeholder="Interprétation..."
                  value={form.bio_biochimie_interpretation ?? ""}
                  onChange={(e) => onChange("bio_biochimie_interpretation", e.target.value)}
                  style={{ borderColor: gc("bio_biochimie_interpretation").color || undefined }} />
              </div>
            </>
          )}
        </Section>
      </>
      )}

      {sub === "coag_groupe" && 
      (
      <>
        {/* ── Coagulation ── */}
        <Section title="Coagulation" confidence={gc("bio_coag")}>
          <div className="rb-result-header">
            <OuiNon name="bio_coag" value={form.bio_coag ?? ""}
              onChange={(v) => onChange("bio_coag", v)} />
            <div className="rb-field-inline">
              <label>Date <ConfidenceLabel confidence={gc("bio_coag_date")} /></label>
              <input type="date" value={form.bio_coag_date ?? ""}
                onChange={(e) => onChange("bio_coag_date", e.target.value)}
                style={{ borderColor: gc("bio_coag_date").color || undefined }} />
            </div>
          </div>
          {form.bio_coag === "oui" && (
            <>
              <div className="rb-row">
                {[["TP(%)","tp"],["TCA(secondes)","tca"],["Fibrine(mg/L)","fibrine"]].map(([label, key]) => (
                  <div key={key} className="rb-field-group">
                    <label>{label} <ConfidenceLabel confidence={gc(`bio_coag_${key}`)} /></label>
                    <input type="number" placeholder="—" step={0.1} min={0}
                      value={form[`bio_coag_${key}`] ?? ""}
                      onChange={(e) => {
                        const val = Math.max(0, parseFloat(e.target.value) || 0).toString();
                        onChange(`bio_coag_${key}`, val);
                      }}
                      style={{ borderColor: gc(`bio_coag_${key}`).color || undefined }} 
                    />
                  </div>
                ))}
              </div>
              <div className="rb-field-group">
                <label>Autres <ConfidenceLabel confidence={gc("bio_coag_autres")} /></label>
                <input type="text" placeholder="—"
                  value={form.bio_coag_autres ?? ""}
                  onChange={(e) => onChange("bio_coag_autres", e.target.value)}
                  style={{ borderColor: gc("bio_coag_autres").color || undefined }} />
              </div>
              <div className="rb-field-group">
                <label>Interprétation <ConfidenceLabel confidence={gc("bio_coag_interpretation")} /></label>
                <textarea rows={3} placeholder="Interprétation..."
                  value={form.bio_coag_interpretation ?? ""}
                  onChange={(e) => onChange("bio_coag_interpretation", e.target.value)}
                  style={{ borderColor: gc("bio_coag_interpretation").color || undefined }} />
              </div>
            </>
          )}
        </Section>

        {/* ── Groupe sanguin ── */}
        <Section title="Groupe sanguin" confidence={gc("bio_groupe")}>
          <div className="rb-result-header">
            <div className="rb-field-inline">
              <label>Groupe <ConfidenceLabel confidence={gc("bio_groupe")} /></label>
              <input type="text" placeholder="A, B, AB, O"
                value={form.bio_groupe ?? ""}
                onChange={(e) => onChange("bio_groupe", e.target.value)}
                style={{ borderColor: gc("bio_groupe").color || undefined }} />
            </div>
            <div className="rb-field-inline">
              <label>Rh <ConfidenceLabel confidence={gc("bio_rh")} /></label>
              <input type="text" placeholder="+ / —"
                value={form.bio_rh ?? ""}
                onChange={(e) => onChange("bio_rh", e.target.value)}
                style={{ borderColor: gc("bio_rh").color || undefined }} />
            </div>
            <div className="rb-field-inline">
              <label>Date <ConfidenceLabel confidence={gc("bio_groupe_date")} /></label>
              <input type="date" value={form.bio_groupe_date ?? ""}
                onChange={(e) => onChange("bio_groupe_date", e.target.value)}
                style={{ borderColor: gc("bio_groupe_date").color || undefined }} />
            </div>
          </div>
        </Section>
      </>
      )}

      {sub === "infect_marqueurs" && 
      (
      <>
        {/* ── Infectieux / Microbiologie ── */}
        <Section title="Infectieux / Microbiologie" confidence={gc("bio_infect")}>
          <div className="rb-result-header">
            <OuiNon name="bio_infect" value={form.bio_infect ?? ""}
              onChange={(v) => onChange("bio_infect", v)} />
            <div className="rb-field-inline">
              <label>Date <ConfidenceLabel confidence={gc("bio_infect_date")} /></label>
              <input type="date" value={form.bio_infect_date ?? ""}
                onChange={(e) => onChange("bio_infect_date", e.target.value)}
                style={{ borderColor: gc("bio_infect_date").color || undefined }} />
            </div>
          </div>
          {form.bio_infect === "oui" && (
            <>
              <div className="rb-row">
                {[["Sérologie HIV","hiv"],["Sérologie Hépatite B","hepb"],["Sérologie Hépatite C","hepc"]].map(([label, key]) => (
                  <div key={key} className="rb-field-group">
                    <label>{label} <ConfidenceLabel confidence={gc(`bio_infect_${key}`)} /></label>
                    <input type="text" placeholder="—"
                      value={form[`bio_infect_${key}`] ?? ""}
                      onChange={(e) => onChange(`bio_infect_${key}`, e.target.value)}
                      style={{ borderColor: gc(`bio_infect_${key}`).color || undefined }} />
                  </div>
                ))}
              </div>
              <div className="rb-field-group">
                <label>Autres <ConfidenceLabel confidence={gc("bio_infect_autres")} /></label>
                <textarea rows={2} placeholder="Autres résultats infectieux..."
                  value={form.bio_infect_autres ?? ""}
                  onChange={(e) => onChange("bio_infect_autres", e.target.value)}
                  style={{ borderColor: gc("bio_infect_autres").color || undefined }} />
              </div>
            </>
          )}
        </Section>

        {/* ── Marqueurs tumoraux ── */}
        <Section title="Marqueurs tumoraux" confidence={gc("bio_marqueurs")}>
          <div className="rb-result-header">
            <OuiNon name="bio_marqueurs" value={form.bio_marqueurs ?? ""}
              onChange={(v) => onChange("bio_marqueurs", v)} />
          </div>
          {form.bio_marqueurs === "oui" && (
            <>
              {[1, 2, 3].map((i) => (
                <div key={i} className="rb-row-marqueur">
                  <div className="rb-field-group">
                    <label>Marqueur {i} <ConfidenceLabel confidence={gc(`bio_marqueur_${i}_nom`)} /></label>
                    <input type="text" placeholder="Nom du marqueur"
                      value={form[`bio_marqueur_${i}_nom`] ?? ""}
                      onChange={(e) => onChange(`bio_marqueur_${i}_nom`, e.target.value)}
                      style={{ borderColor: gc(`bio_marqueur_${i}_nom`).color || undefined }} />
                  </div>
                  <div className="rb-field-group">
                    <label>Résultat <ConfidenceLabel confidence={gc(`bio_marqueur_${i}_resultat`)} /></label>
                    <input type="text" placeholder="—"
                      value={form[`bio_marqueur_${i}_resultat`] ?? ""}
                      onChange={(e) => onChange(`bio_marqueur_${i}_resultat`, e.target.value)}
                      style={{ borderColor: gc(`bio_marqueur_${i}_resultat`).color || undefined }} />
                  </div>
                  <div className="rb-field-group">
                    <label>Date <ConfidenceLabel confidence={gc(`bio_marqueur_${i}_date`)} /></label>
                    <input type="date"
                      value={form[`bio_marqueur_${i}_date`] ?? ""}
                      onChange={(e) => onChange(`bio_marqueur_${i}_date`, e.target.value)}
                      style={{ borderColor: gc(`bio_marqueur_${i}_date`).color || undefined }} />
                  </div>
                </div>
              ))}
              <div className="rb-field-group">
                <label>Interprétation <ConfidenceLabel confidence={gc("bio_marqueurs_interpretation")} /></label>
                <textarea rows={3} placeholder="Interprétation..."
                  value={form.bio_marqueurs_interpretation ?? ""}
                  onChange={(e) => onChange("bio_marqueurs_interpretation", e.target.value)}
                  style={{ borderColor: gc("bio_marqueurs_interpretation").color || undefined }} />
              </div>
            </>
          )}
        </Section>
      </>
      )}
      {sub === "cyto_myelo" && 
      (
      <>
          {/* ── Cytologie ── */}
          <Section title="Cytologie" confidence={gc("bio_cyto")}>
            <div className="rb-result-header">
              <OuiNon name="bio_cyto" value={form.bio_cyto ?? ""}
                onChange={(v) => onChange("bio_cyto", v)} />
            </div>
            {form.bio_cyto === "oui" && (
              <>
                <div className="rb-row">
                  <div className="rb-field-group">
                    <label>Type <ConfidenceLabel confidence={gc("bio_cyto_type")} /></label>
                    <div className="rb-oui-non">
                      {["Ponction Tumeur", "Épanchement"].map((t) => (
                        <label key={t} className="rb-radio-label">
                          <input type="radio" name="cyto_type" value={t}
                            checked={form.bio_cyto_type === t}
                            onChange={() => onChange("bio_cyto_type", t)} />
                          {t}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="rb-field-group">
                    <label>Date <ConfidenceLabel confidence={gc("bio_cyto_date")} /></label>
                    <input type="date" value={form.bio_cyto_date ?? ""}
                      onChange={(e) => onChange("bio_cyto_date", e.target.value)}
                      style={{ borderColor: gc("bio_cyto_date").color || undefined }} />
                  </div>
                </div>
                <div className="rb-row">
                  <div className="rb-field-group">
                    <label>N° lame <ConfidenceLabel confidence={gc("bio_cyto_lame")} /></label>
                    <input type="text" placeholder="—"
                      value={form.bio_cyto_lame ?? ""}
                      onChange={(e) => onChange("bio_cyto_lame", e.target.value)}
                      style={{ borderColor: gc("bio_cyto_lame").color || undefined }} />
                  </div>
                  <div className="rb-field-group">
                    <label>Localisation <ConfidenceLabel confidence={gc("bio_cyto_localisation")} /></label>
                    <input type="text" placeholder="—"
                      value={form.bio_cyto_localisation ?? ""}
                      onChange={(e) => onChange("bio_cyto_localisation", e.target.value)}
                      style={{ borderColor: gc("bio_cyto_localisation").color || undefined }} />
                  </div>
                </div>
                <div className="rb-field-group">
                  <label>Interprétation <ConfidenceLabel confidence={gc("bio_cyto_interpretation")} /></label>
                  <textarea rows={3} placeholder="Interprétation..."
                    value={form.bio_cyto_interpretation ?? ""}
                    onChange={(e) => onChange("bio_cyto_interpretation", e.target.value)}
                    style={{ borderColor: gc("bio_cyto_interpretation").color || undefined }} />
                </div>
              </>
            )}
          </Section>

          {/* ── Myélogramme ── */}
          <Section title="Myélogramme(s)" confidence={gc("bio_myelo")}>
            <div className="rb-result-header">
              <OuiNon name="bio_myelo" value={form.bio_myelo ?? ""}
                onChange={(v) => onChange("bio_myelo", v)} />
              <div className="rb-field-inline">
                <label>Date <ConfidenceLabel confidence={gc("bio_myelo_date")} /></label>
                <input type="date" value={form.bio_myelo_date ?? ""}
                  onChange={(e) => onChange("bio_myelo_date", e.target.value)}
                  style={{ borderColor: gc("bio_myelo_date").color || undefined }} />
              </div>
            </div>
            {form.bio_myelo === "oui" && (
              <>
                <div className="rb-row">
                  <div className="rb-field-group">
                    <label>N° lame <ConfidenceLabel confidence={gc("bio_myelo_lame")} /></label>
                    <input type="text" placeholder="—"
                      value={form.bio_myelo_lame ?? ""}
                      onChange={(e) => onChange("bio_myelo_lame", e.target.value)}
                      style={{ borderColor: gc("bio_myelo_lame").color || undefined }} />
                  </div>
                  <div className="rb-field-group">
                    <label>Localisation <ConfidenceLabel confidence={gc("bio_myelo_localisation")} /></label>
                    <input type="text" placeholder="—"
                      value={form.bio_myelo_localisation ?? ""}
                      onChange={(e) => onChange("bio_myelo_localisation", e.target.value)}
                      style={{ borderColor: gc("bio_myelo_localisation").color || undefined }} />
                  </div>
                </div>
                <div className="rb-field-group">
                  <label>Interprétation <ConfidenceLabel confidence={gc("bio_myelo_interpretation")} /></label>
                  <textarea rows={3} placeholder="Interprétation..."
                    value={form.bio_myelo_interpretation ?? ""}
                    onChange={(e) => onChange("bio_myelo_interpretation", e.target.value)}
                    style={{ borderColor: gc("bio_myelo_interpretation").color || undefined }} />
                </div>
              </>
            )}
          </Section>

      </>
      )}
      {sub === "lcr_histo" && 
      (
      <>
        {/* ── LCR ── */}
        <Section title="LCR" confidence={gc("bio_lcr")}>
          <div className="rb-result-header">
            <OuiNon name="bio_lcr" value={form.bio_lcr ?? ""}
              onChange={(v) => onChange("bio_lcr", v)} />
            <div className="rb-field-inline">
              <label>Date <ConfidenceLabel confidence={gc("bio_lcr_date")} /></label>
              <input type="date" value={form.bio_lcr_date ?? ""}
                onChange={(e) => onChange("bio_lcr_date", e.target.value)}
                style={{ borderColor: gc("bio_lcr_date").color || undefined }} />
            </div>
          </div>
          {form.bio_lcr === "oui" && (
            <div className="rb-field-group">
              <label>Interprétation <ConfidenceLabel confidence={gc("bio_lcr_interpretation")} /></label>
              <textarea rows={3} placeholder="Interprétation..."
                value={form.bio_lcr_interpretation ?? ""}
                onChange={(e) => onChange("bio_lcr_interpretation", e.target.value)}
                style={{ borderColor: gc("bio_lcr_interpretation").color || undefined }} />
            </div>
          )}
        </Section>

        {/* ── Histologie ── */}
        <Section title="Histologie" confidence={gc("bio_histo")}>
          <div className="rb-result-header">
            <OuiNon name="bio_histo" value={form.bio_histo ?? ""}
              onChange={(v) => onChange("bio_histo", v)} />
            <div className="rb-field-inline">
              <label>Date <ConfidenceLabel confidence={gc("bio_histo_date")} /></label>
              <input type="date" value={form.bio_histo_date ?? ""}
                onChange={(e) => onChange("bio_histo_date", e.target.value)}
                style={{ borderColor: gc("bio_histo_date").color || undefined }} />
            </div>
          </div>
          {form.bio_histo === "oui" && (
            <>
              <div className="rb-row">
                <div className="rb-field-group">
                  <label>Laboratoire <ConfidenceLabel confidence={gc("bio_histo_labo")} /></label>
                  <input type="text" placeholder="—"
                    value={form.bio_histo_labo ?? ""}
                    onChange={(e) => onChange("bio_histo_labo", e.target.value)}
                    style={{ borderColor: gc("bio_histo_labo").color || undefined }} />
                </div>
                <div className="rb-field-group">
                  <label>Immunohistochimie <ConfidenceLabel confidence={gc("bio_histo_ihc")} /></label>
                  <OuiNon name="bio_histo_ihc" value={form.bio_histo_ihc ?? ""}
                    onChange={(v) => onChange("bio_histo_ihc", v)} />
                </div>
              </div>
              <div className="rb-field-group">
                <label>Conclusion du pathologiste <ConfidenceLabel confidence={gc("bio_histo_conclusion")} /></label>
                <textarea rows={4} placeholder="Conclusion..."
                  value={form.bio_histo_conclusion ?? ""}
                  onChange={(e) => onChange("bio_histo_conclusion", e.target.value)}
                  style={{ borderColor: gc("bio_histo_conclusion").color || undefined }} />
              </div>
            </>
          )}
        </Section>

      </>
      )}

      {sub === "autres_bio" && 
      (
      <>
        {/* ── Autres examens biologiques ── */}
        <Section title="Autres examens biologiques" confidence={gc("bio_autres")}>
          <div className="rb-result-header">
            <OuiNon name="bio_autres" value={form.bio_autres ?? ""}
              onChange={(v) => onChange("bio_autres", v)} />
            <div className="rb-field-inline">
              <label>Date <ConfidenceLabel confidence={gc("bio_autres_date")} /></label>
              <input type="date" value={form.bio_autres_date ?? ""}
                onChange={(e) => onChange("bio_autres_date", e.target.value)}
                style={{ borderColor: gc("bio_autres_date").color || undefined }} />
            </div>
          </div>
          {form.bio_autres === "oui" && (
            <div className="rb-field-group">
              <label>Préciser <ConfidenceLabel confidence={gc("bio_autres_details")} /></label>
              <textarea rows={4} placeholder="Préciser..."
                value={form.bio_autres_details ?? ""}
                onChange={(e) => onChange("bio_autres_details", e.target.value)}
                style={{ borderColor: gc("bio_autres_details").color || undefined }} />
            </div>
          )}
        </Section>

      </>
      )}

    </div>
  );
};

export default TabBiologie;